import crypto from 'crypto'
import httpManager from '../../util/common';
import UserCenterMenu from '@/user_center/components/UserCenterMenu'

let edit_password = {
  components: {UserCenterMenu},
  // props: ['oaid'],
  data: () => {
    return {
      originalPwdErrMsg: null,
      originalPwdErrMsgShow: false,
      newPwdErrMsg: null,
      newPwdErrMsgShow: false,
      confirmPwdErrMsg: null,
      confirmPwdErrMsgShow: false,
      original_pwd: null,
      new_pwd: null,
      confirm_pwd: null,
      showSuccessTips: true,
      user_account: sessionStorage.getItem('username'),
      user: ''
    }
  },
  methods: {
    inputOnFocus () {
      this.originalPwdErrMsgShow = false
      this.newPwdErrMsgShow = false
      this.confirmPwdErrMsgShow = false
    },
    on_submit (e) {
      let self = this
      if (!self.original_pwd) {
        self.originalPwdErrMsg = self.$t('user.originalPwdRequired')
        self.originalPwdErrMsgShow = true
        return
      }
      if (!self.new_pwd) {
        self.newPwdErrMsg = self.$t('user.newPwdRequired')
        self.newPwdErrMsgShow = true
        return
      }
      if (self.new_pwd.length < 8) {
        self.newPwdErrMsg = self.$t('user.charactersError')
        self.newPwdErrMsgShow = true
        return
      }
      if (self.new_pwd !== self.confirm_pwd) {
        self.confirmPwdErrMsg = self.$t('user.inconsistentError')
        self.confirmPwdErrMsgShow = true
        return
      }
      let originalPwd = crypto.createHash('md5').update(self.original_pwd).digest('hex')
      let newPwd = crypto.createHash('md5').update(self.new_pwd).digest('hex')
      let body = {
        'account': sessionStorage.getItem('username'),
        'original_pwd': originalPwd,
        'new_pwd': newPwd
      }
      // 先检验原始密码是否正确
      httpManager('edit_password', null, body)
        .then(response => {
          if (!response.data.success) {
            self.originalPwdErrMsg = self.$t('user.wrongPassword')
            self.originalPwdErrMsgShow = true
          } else {
            self.$message.config({top: `30%`, duration: 2})
            self.$message.success('Success')
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
export default edit_password



// WEBPACK FOOTER //
// ./src/user_center/js/edit_password.js